var map = {
	"./air-nga-en/assets/left-keyboard-arrow.png": 34031,
	"./ais-tai-en/assets/left-keyboard-arrow.png": 11126,
	"./ais-tai-tha/assets/left-keyboard-arrow.png": 46602,
	"./demo-arabic/assets/left-keyboard-arrow.png": 81986,
	"./demo-et-en/assets/left-keyboard-arrow.png": 78651,
	"./demo-romanian/assets/left-keyboard-arrow.png": 49325,
	"./demo-um-en/assets/left-keyboard-arrow.png": 16354,
	"./dtac-tai-en/assets/left-keyboard-arrow.png": 6381,
	"./dtac-tai-tha/assets/left-keyboard-arrow.png": 49639,
	"./ethiotel-et-amh/assets/left-keyboard-arrow.png": 10449,
	"./ethiotel-et-en/assets/left-keyboard-arrow.png": 51948,
	"./mtn-cg-fr/assets/left-keyboard-arrow.png": 23289,
	"./mtn-ci-fr/assets/left-keyboard-arrow.png": 26871,
	"./mtn-cmr-fr/assets/left-keyboard-arrow.png": 65731,
	"./mtn-gha-en/assets/left-keyboard-arrow.png": 33044,
	"./mtn-nga-en/assets/left-keyboard-arrow.png": 38128,
	"./mtn-zam-en/assets/left-keyboard-arrow.png": 20450,
	"./saf-ke-en/assets/left-keyboard-arrow.png": 45971,
	"./saudi-uae-en/assets/left-keyboard-arrow.png": 84562,
	"./tlk-za-en/assets/left-keyboard-arrow.png": 60207,
	"./vc-za-en/assets/left-keyboard-arrow.png": 30019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78361;